import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useUser } from '@/lib/auth';
import { isSupportedLanguage } from '@/lib/i18n/displayLanguage';
import { getCurrentLanguage } from '@/lib/i18n/getCurrentLanguage';
import { DateTimePreferencesContext } from '../context/DateTimePreferencesContext';
import { getDefaultDateTimePreferences } from '../lib/preferences';

type DateTimePreferencesProviderProps = {
  children: ReactNode;
};

export const DateTimePreferencesProvider = ({
  children,
}: DateTimePreferencesProviderProps) => {
  useTranslation();
  const { data: user } = useUser();
  const userLanguage = user?.language;
  const language = isSupportedLanguage(userLanguage)
    ? userLanguage
    : getCurrentLanguage();
  const preferences = getDefaultDateTimePreferences(language);

  return (
    <DateTimePreferencesContext value={{ language, preferences }}>
      {children}
    </DateTimePreferencesContext>
  );
};
